<header class="central__header">
  <div>
    <span class="central__eyebrow">{{ configuring ? 'NOTIFICAÇÕES' : 'SUA EMPRESA EM DIA' }}</span>
    <h2 id="central-notificacoes-titulo">{{ configuring ? 'Preferências' : 'Notificações' }}</h2>
    <p>{{ configuring ? 'Defina quando sua equipe deve ser avisada.' : 'O que merece sua atenção agora.' }}</p>
  </div>
  <div class="central__tools">
    @if (canConfigure) {
      <button matIconButton type="button" [attr.aria-label]="configuring ? 'Voltar às notificações' : 'Configurar notificações'" [attr.aria-pressed]="configuring" (click)="configure()">
        <mat-icon [svgIcon]="configuring ? 'arrow_back' : 'settings'" />
      </button>
    }
    <button matIconButton type="button" aria-label="Fechar notificações" (click)="close()"><mat-icon svgIcon="close" /></button>
  </div>
</header>

@if (configuring) {
  <section class="central__body" aria-label="Configurações de notificações">
    <p class="central__scope">As preferências são compartilhadas por toda a empresa, inclusive no aplicativo.</p>
    @if (configLoading) {
      <mat-spinner diameter="28" aria-label="Carregando configurações" />
    }
    @if (configError) { <p role="alert" class="central__error">{{ configError }}</p> }
    @for (group of [{prefix: 'account_payable_', title: 'Pagamentos', description: 'Contas a pagar', icon: 'arrow_forward'}, {prefix: 'account_receivable_', title: 'Recebimentos', description: 'Contas a receber', icon: 'arrow_back'}]; track group.prefix) {
      @if (configs.length > 0) {
        <section class="central__preferences" [attr.aria-label]="group.title">
          <header class="central__preferences-heading">
            <span class="central__preferences-icon"><mat-icon [svgIcon]="group.icon" aria-hidden="true" /></span>
            <div><h3>{{ group.title }}</h3><p>{{ group.description }}</p></div>
          </header>
          @for (config of configs; track config.action) {
            @if (config.action.startsWith(group.prefix)) {
              @if (isDays(config)) {
                <div class="central__lead-time">
                  <label [for]="config.action">Avisar com antecedência<span>De 0 a 365 dias</span></label>
                  <div class="central__lead-time-controls">
                    <div class="central__days-input">
                      <input [id]="config.action" [attr.aria-label]="configLabels[config.action]" type="number" min="0" max="365" step="1" [ngModel]="config.value" #days="ngModel" [disabled]="savingConfig.has(config.action)" />
                      <span aria-hidden="true">{{ days.value === 1 ? 'dia' : 'dias' }}</span>
                    </div>
                    <button matButton type="button" [attr.aria-label]="'Salvar antecedência de ' + group.title.toLowerCase()" [disabled]="days.invalid || days.value === config.value || savingConfig.has(config.action)" (click)="saveConfig(config, +days.value)">{{ savingConfig.has(config.action) ? 'Salvando…' : 'Salvar' }}</button>
                  </div>
                </div>
              } @else {
                <div class="central__config">
                  <span [id]="config.action + '-label'">{{ configLabels[config.action] }}</span>
                  <mat-slide-toggle hideIcon [aria-labelledby]="config.action + '-label'" [checked]="config.value === true" [disabled]="savingConfig.has(config.action)" (change)="toggleConfig(config, $event)" />
                </div>
              }
            }
          }
        </section>
      }
    }
    @if (!configLoading && configs.length === 0) {
      <button matButton type="button" (click)="loadConfig()">Tentar novamente</button>
    }
    <aside class="central__preferences-note"><mat-icon svgIcon="schedule" aria-hidden="true" /><p>Aportes consideram os próximos 7 dias. Falhas de cobrança e de notas ficam visíveis até serem resolvidas.</p></aside>
  </section>
} @else {
  <nav class="central__tabs" aria-label="Filtrar notificações">
    @for (item of tabs; track item.value) {
      <button type="button" [class.central__tab--active]="tab === item.value" [attr.aria-pressed]="tab === item.value" (click)="selectTab(item.value)">{{ item.label }}</button>
    }
  </nav>
  <div class="central__summary" aria-live="polite">
    <span>{{ loading ? 'Atualizando…' : total + (total === 1 ? ' notificação' : ' notificações') }}</span>
    @if (unread > 0) { <span class="central__unread">{{ unread }} não {{ unread === 1 ? 'lida' : 'lidas' }}</span> }
  </div>
  <section class="central__body" [attr.aria-busy]="loading" aria-label="Lista de notificações">
    @if (actionError) { <p class="central__error" role="alert">{{ actionError }}</p> }
    @if (loading) {
      <div class="central__state"><mat-spinner diameter="32" aria-label="Carregando notificações" /><p>Consultando suas pendências…</p></div>
    } @else if (error) {
      <div class="central__state" role="alert">
        <mat-icon svgIcon="error" /><h3>{{ error }}</h3><p>Suas notificações continuam salvas. Tente de novo em instantes.</p>
        <button matButton type="button" (click)="load()">Tentar novamente</button>
      </div>
    } @else {
      @if (stale) {
        <p class="central__error" role="status">Não foi possível atualizar agora. Exibindo a última consulta disponível.</p>
        <button matButton type="button" (click)="load()">Tentar novamente</button>
      }
      @for (alert of alerts; track alert.id) {
        <article class="central__card" [class.central__card--unread]="!alert.read" [class.central__card--resolved]="!!alert.resolved_at">
          <div class="central__card-top">
            <span class="central__severity" [class.central__severity--critical]="alert.severity === 'critical' && !alert.resolved_at" [class.central__severity--warning]="alert.severity === 'warning' && !alert.resolved_at">
              @switch (icon(alert)) {
                @case ('check_circle') { <mat-icon svgIcon="check_circle" /> }
                @case ('payments') { <mat-icon svgIcon="payments" /> }
                @case ('error') { <mat-icon svgIcon="error" /> }
                @case ('warning') { <mat-icon svgIcon="warning" /> }
                @default { <mat-icon svgIcon="schedule" /> }
              }{{ severity(alert) }}
            </span>
            @if (!alert.read) { <span class="central__new">Não lida</span> }
          </div>
          <h3>{{ alert.title }}</h3>
          <p class="central__message">{{ alert.message }}</p>
          @if (alert.kind.startsWith('funding_')) { <span class="central__muted">Maior déficit projetado nos próximos 7 dias</span> }
          @if (alert.amount !== null) { <strong class="central__amount">{{ money(alert.amount) }}</strong> }
          <div class="central__meta">
            @if (!alert.kind.startsWith('funding_')) {
              <span>{{ quantity(alert) }}</span>
            }
            @if (alert.reference_date) { <span>Referência: {{ date(alert.reference_date) }}</span> }
            @if (alert.resolved_at) { <span>Resolvida em {{ date(alert.resolved_at) }}</span> }
            @else { <span>Identificada em {{ date(alert.created_at) }}</span> }
          </div>
          <div class="central__actions">
            <button matButton type="button" (click)="open(alert)">{{ alert.action_label }}<mat-icon svgIcon="arrow_forward" iconPositionEnd /></button>
            @if (!alert.read) {
              <button matButton type="button" data-read [disabled]="marking.has(alert.id) || markingAll" (click)="markRead(alert)">Marcar como lida</button>
            } @else { <span class="central__muted">Lida</span> }
          </div>
        </article>
      } @empty {
        <div class="central__state">
          <span class="central__empty-icon"><mat-icon svgIcon="check_circle" /></span>
          <h3>{{ tab === 'history' ? 'Nenhuma pendência resolvida ainda' : tab === 'unread' ? 'Tudo lido por aqui' : 'Nenhuma pendência financeira no momento' }}</h3>
          <p>{{ tab === 'history' ? 'Quando uma situação for resolvida, o alerta aparecerá aqui.' : tab === 'unread' ? 'As pendências continuam disponíveis até serem resolvidas.' : 'Novos alertas aparecerão aqui quando precisarem da sua atenção.' }}</p>
        </div>
      }
    }
  </section>
  <footer class="central__footer">
    @if (!loading && !error && lastPage > 1) {
      <nav class="central__pagination" aria-label="Paginação de notificações">
        <button matButton type="button" [disabled]="page <= 1" (click)="load(page - 1)">Anterior</button>
        <span>{{ page }} de {{ lastPage }}</span>
        <button matButton type="button" [disabled]="page >= lastPage" (click)="load(page + 1)">Próxima</button>
      </nav>
    }
    <button matButton type="button" [disabled]="!unread || markingAll || marking.size > 0 || loading || !!error" (click)="markAll()">Marcar todas como lidas</button>
    <p class="central__muted">{{ syncedAt ? 'Atualizado em ' + time(syncedAt) : 'Aguardando atualização' }}</p>
    <p class="central__footnote">A leitura é só sua. As pendências são da empresa.</p>
  </footer>
}
